import { createAction, useSelector, assertPartialSchema, v } from "../../../lib";
import { toSerializableValue } from "../../serializable";

export const REQUEST_ERROR = "REQUEST_ERROR";
export const doREQUEST_ERROR = createAction(REQUEST_ERROR);

export const REQUEST_COMPLETE = "REQUEST_COMPLETE";
export const doREQUEST_COMPLETE = createAction(REQUEST_COMPLETE);

export const REQUEST_SKIP = "REQUEST_SKIP";
export const doREQUEST_SKIP = createAction(REQUEST_SKIP);

export const RESET_ERROR = "RESET_ERROR";
export const doRESET_ERROR = createAction(RESET_ERROR);

export const useSelectRequestComplete = (requestId) =>
  useSelector((state) => {
    return state.requestState[requestId] || null;
  });

export const useSelectRequestState = () =>
  useSelector((state) => {
    return state.requestState;
  });

export const requestStateActionCreators = {
  doREQUEST_ERROR,
  doREQUEST_COMPLETE,
  doREQUEST_SKIP,
  doRESET_ERROR,
};

const requestStateDefaultState = {};
export const requestStateReducer = (
  state = requestStateDefaultState,
  { type, payload, setRequestResult },
) => {
  if (![REQUEST_COMPLETE, REQUEST_ERROR, RESET_ERROR].includes(type)) {
    return state;
  }

  if (!payload) return state;

  if (type == REQUEST_COMPLETE || type == REQUEST_ERROR) {
    assertPartialSchema({
      payload,
      schema: v.object({
        requestId: v.string().required(),
        fromType: v.string().required(),
      }),
    });

    assertPartialSchema({
      setRequestResult,
      schema: v.function().optional(),
    });
  }
  const requestId = payload?.requestId;

  switch (type) {
    case REQUEST_ERROR: {
      const serializablePayload = toSerializableValue(payload);
      const refreshTokenError = serializablePayload?.payload?.serverError === "jwt expired";

      setRequestResult?.({
        requestType: payload.fromType,
        success: false,
        result: payload,
      });

      return {
        ...state,
        [requestId]: {
          success: false,
          payload: serializablePayload,
          refreshTokenError,
        },
        hasError: !refreshTokenError && requestId,
      };
    }
    case REQUEST_COMPLETE: {
      setRequestResult?.({
        requestType: payload.fromType,
        success: true,
        result: payload,
      });

      return {
        ...state,
        [requestId]: {
          success: true,
          type: payload.fromType,
          // payload,
        },
      };
    }

    case REQUEST_SKIP:
      return {
        ...state,
        [requestId]: {
          success: true,
          type: payload.fromType,
        },
      };
    case RESET_ERROR:
      return { ...state, hasError: null };
    default:
      return state;
  }
};
